<template>
  <div class="comp-xl-search" v-if="searchObj && searchObj.list && searchObj.list.length">
    <template v-if="isNameRepeat"> {{ $t('tips.advSearchNameRepeat', { name: isNameRepeat }) }} </template>
    <template v-else-if="customHasName">{{ $t('tips.advSearchCustomIsNotEmpty') }}</template>
    <template v-else>
      <template v-if="searchObj?.type === 'filter'">
        <adv-filter :entity="entity" :leaveStatus="leaveStatus" :hasLabel="hasLabel" :uuid="searchObj.uuid" :out-wrap="searchObj?.filterWrap ?? '.comp-xl-search'" :title="searchObj?.filterTitle" :list="searchList" :val="searchDataObj" :defval="searchDefObj" :isOut="searchObj?.isOut ? true : false" @cb="getSearch" />
      </template>
      <template v-else>
        <template v-for="item in searchList" :key="item.name">
          <div class="jw-search-item" :class="{ 'jw-search-item-auto': item.type === 'checkbox' || item.type === 'radio' }">
            <div class="jw-search-item-label" :title="item.label" v-if="hasLabel && item.label">{{ item.label }}</div>
            <!-- 时间控件 -->
            <div v-if="item.type === 'datePicker'" class="jw-search-item-inner" :class="{ 'jw-search-item-big': isCustomDate(item) }"><xl-date-picker :subcol="item" @cb="getSearch" /></div>
            <!-- 输入框 -->
            <div v-if="item.type === 'input'" class="jw-search-item-inner"><xl-input :subcol="item" @cb="getSearch" /></div>
            <!-- select -->
            <div v-if="item.type === 'select'" class="jw-search-item-inner"><xl-select :subcol="item" @cb="getSearch" /></div>
            <!-- checkbox -->
            <div v-if="item.type === 'checkbox'" class="jw-search-item-inner jw-search-item-long"><xl-checkbox :subcol="item" @cb="getSearch" /></div>
            <!-- radio -->
            <div v-if="item.type === 'radio'" class="jw-search-item-inner jw-search-item-long"><xl-radio :subcol="item" @cb="getSearch" /></div>
            <!-- cascader -->
            <div v-if="item.type === 'cascader'" class="jw-search-item-inner"><xl-cascader :subcol="item" @cb="getSearch" /></div>
            <!-- treeSelect -->
            <div v-if="item.type === 'treeSelect'" class="jw-search-item-inner"><xl-tree-select :subcol="item" @cb="getSearch" /></div>
            <!-- member -->
            <div v-if="item.type === 'member'" class="jw-search-item-inner">
              <xl-member :leaveStatus="leaveStatus" :subcol="item" @cb="getSearch" />
            </div>
            <!-- 自定义 -->
            <!-- number -->
            <div v-if="item.type === 'number'" class="jw-search-item-inner"><xl-number :subcol="item" @cb="getSearch" /></div>
            <!-- 自定义 -->
            <div v-if="item.type === 'custom'" class="jw-search-item-inner" :class="{ 'jw-search-item-big': item.width === 'auto' }"><slot :name="item.name"></slot></div>
          </div>
        </template>
        <slot></slot>
      </template>
    </template>
  </div>
</template>

<script>
// watchEffect
import { ref, computed, watch } from 'vue';
import AdvFilter from './adv-filter/adv-filter.vue';
import XlInput from './xl-input/xl-input.vue';
import XlSelect from './xl-select/xl-select.vue';
import XlCheckbox from './xl-checkbox/xl-checkbox.vue';
import XlRadio from './xl-radio/xl-radio.vue';
import XlCascader from './xl-cascader/xl-cascader.vue';
import XlTreeSelect from './xl-tree-select/xl-tree-select.vue';
import XlMember from './xl-member/xl-member.vue';
import XlNumber from './xl-number/xl-number.vue';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'XlSearch',
  components: {
    AdvFilter,
    XlInput,
    XlSelect,
    XlCheckbox,
    XlRadio,
    XlCascader,
    XlTreeSelect,
    XlMember,
    XlNumber
  },
  props: {
    searchObj: {
      type: Object,
      default() {
        return {
          list: []
        };
      }
    },
    leaveStatus: {
      type: Number,
      default: 0
    },
    entity: {
      type: [Number, String],
      default: ''
    }
  },
  emits: ['cb'],
  setup(props, ctx) {
    // 检测是否重复name
    const isNameRepeat = computed(() => {
      const list = props.searchObj?.list || [];
      const n = [];
      let f = false;
      for (let index = 0; index < list.length; index++) {
        const name = n.find((el) => el === list[index].name);
        if (name) {
          f = list[index].name;
          break;
        }
        n.push(list[index].name);
      }
      return f;
    });
    // 检测 custom 是否有name
    const customHasName = computed(() => {
      const custom = props.searchObj?.list.filter((el) => el.type === 'custom');
      const name = custom.find((el) => el.name === undefined || el.name === null || el.name === '');
      return name !== undefined;
    });
    // 是否有label
    const hasLabel = computed(() => (props.searchObj?.hasLabel === false ? false : true));
    const isCustomDate = (p) => p?.customArray?.length || !p.customArray;

    // 处理传入的数据
    const searchList = computed(() => {
      const list = props?.searchObj?.list || [];
      return list?.map((el) => {
        const ele = { ...el };
        ele.size = ele.size || props.searchObj.size || 'small';
        if (el.value === undefined) ele.value = '';
        if (ele.type === 'datePicker') {
          if (ele.customShow === undefined) ele.customShow === false;
          if (el.value === undefined) ele.value = [];
        }
        // 如果有props.searchObj.val 则有默认值
        const sdv = props.searchObj.val;
        // console.log(120114, ele.name, sdv?.[ele.name]);
        // // 赋值
        if (sdv?.[ele.name] || sdv?.[ele.name] === 0) {
          ele.value = sdv[ele.name];
          // console.log(120117, ele.value, sdv[el.name]);
          if (ele.type === 'input' || ele.type === 'number') {
            ele.value = sdv[el.name]?.val;
            if (el.select) {
              ele.select.value = sdv[el.name]?.selectVal;
            }
          }
        }

        return ele;
      });
    });
    // 搜索的结果
    const searchDataObj = ref({});

    // 传入的默认值
    const searchDefObj = ref({});
    if (props.searchObj?.val) {
      searchDefObj.value = JSON.parse(JSON.stringify(props.searchObj?.val)) || {};
    }
    // 搜索回调
    const getSearch = (v, t) => {
      console.log(265106, v, t, 't', t, JSON.stringify(v), JSON.stringify(searchDataObj.value));
      const o = searchDataObj.value;
      if (v) searchDataObj.value = Object.assign(o, { ...v });
      const obj = {};
      for (const key in searchDataObj.value) {
        if (Object.hasOwnProperty.call(searchDataObj.value, key)) {
          const el = searchDataObj.value[key];
          // obj[key] = el;
          if (el !== undefined) {
            obj[key] = el;
          }
          //  else {
          //   obj[key] = undefined
          // }
        }
      }
      searchDataObj.value = obj;
      ctx.emit('cb', obj);
    };

    // onMounted(() => {
    //   console.log(265,12,props.searchObj?.list)
    //   const unHandle = props.searchObj?.list.find(el => el.name === 'unhandle')
    //   console.log(265,121, unHandle)
    //   if(unHandle) {
    //     console.log(265,1211, unHandle)
    //     searchDataObj.value = {
    //       'unHandle': unHandle.value
    //     }
    //     console.log(265,12111, searchDataObj.value)
    //   }
    //   console.log(265,122222, props.searchObj?.list,unHandle,searchDataObj.value)
    //   getSearch();
    // })

    // watchEffect(() => {
    //   if (props.searchObj?.val) {
    //     searchDefObj.value = { ...searchDefObj.value, ...props.searchObj?.val } || {};
    //     // ctx.emit('cb', searchDefObj.value);
    //   }
    //   console.log(12011, props.searchObj?.val, searchDefObj.value);
    // });
    const handleVal = () => {
      if (props.searchObj?.val && Object.keys(props.searchObj?.val)?.length) {
        searchDefObj.value = { ...searchDefObj.value, ...props.searchObj?.val } || {};
        // ctx.emit('cb', searchDefObj.value);
        if (props.searchObj?.type !== 'filter') {
          ctx.emit('cb', searchDefObj.value);
        }
      }
    };
    watch(
      () => props.searchObj,
      (v) => {
        console.log(1201, 'vvvv', v);
        handleVal();
      },
      {
        deep: true
      }
    );

    return {
      isNameRepeat,
      customHasName,
      searchDataObj,
      searchDefObj,
      hasLabel,
      searchList,
      getSearch,
      isCustomDate
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-search.less';
</style>
